import { useEffect } from 'react';
import { useLocation } from '@wikom/wikom-router';
import usePrevious from './usePrevious';
var useLocationChange = function (action) {
    var location = useLocation();
    var prevLocation = usePrevious(location);
    useEffect(function () {
        action(location, prevLocation);
    }, [location]);
};
export default useLocationChange;
